import type { PetApplicationFormDraft } from "@/pages/daycare-hotel/reservation/petApplicationDraft";

export type ApplicationSubmissionMode = "immediate" | "deferred";

export async function dispatchApplicationSubmission<T>({
  mode,
  draft,
  persist,
  onDraftSubmit,
}: {
  mode: ApplicationSubmissionMode;
  draft: PetApplicationFormDraft;
  persist: (draft: PetApplicationFormDraft) => Promise<T>;
  onDraftSubmit?: (draft: PetApplicationFormDraft) => void;
}): Promise<T | null> {
  if (mode === "deferred") {
    onDraftSubmit?.(draft);
    return null;
  }

  return persist(draft);
}
